// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"147":"inventario","443":"about","550":"pedidos","919":"pedidoRealizado"}[chunkId] + "-legacy." + {"147":"13011fb8","443":"95d7ed38","550":"4a8ad6bc","919":"07025a4b"}[chunkId] + ".js";
};